import {SpinnerContainer,SpinnerOverlay} from './spinner.style'

export const Spinner=()=> <SpinnerOverlay>
    <SpinnerContainer />
    </SpinnerOverlay>